export default "__VITE_ASSET__CJq_pu8s__"